/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, w, SCS) {
	"use strict";
	/*globals Tc */

	/**
	 * MyStatus
	 *
	 * @author Sebastian Bartels
	 * @namespace Tc.Module
	 * @class MyStatus
	 * @extends Tc.Module
	 */
	Tc.Module.MyStatus = Tc.Module.extend({

		on: function(callback) {
			var mod = this;
			
			// Declare vars
			mod.declareVars();
						
			// If we are on mobile page process HTML and fire up window resize event
			if (SCS.utils.isMobilePage()) {
				mod.prepareMobileContent();
				mod.updateStatusBarsOnResize();
			}

			// get user data
			mod.userData = mod.$ctx.find('.userdata:first').data();
			if (mod.userData.level === "undefined" || mod.userData.level === "nodisplay") {
				mod.userHasNoLevel = true;
			}

			// get available levels
			mod.getAvailableLevels();

			// mark the target-step(s) as active
			mod.$ctx.find('.step' +
                (mod.userData.level ? '.' + mod.userData.level : '') +
                ', .marker-line' +
                (mod.userData.level ? '.' + mod.userData.level : '')).addClass('active');

			// update the status bars
			mod.updateStatusBar('sales');
			mod.updateStatusBar('training');
			
			callback();
		},

		getAvailableLevels: function () {
			var mod = this,
				levelMarkers = mod.$ctx.find('.progressbar:first .marker-line');

			mod.$ctx.find('.levels:first > span[data-name]').each(function (i) {
				var data = $(this).data();

				data.index = i;
				data.markerPosition = levelMarkers.filter('.' + data.name).position().left;

				mod.levels.push(data);

				// get users target level
				if (mod.userData.level === data.name) {
					mod.userTargetLevelIndex = data.index;
				}

				// get users current index
				if (mod.userData.salesValue >= data.salesValue) {
					mod.userCurrentLevelIndex.sales = data.index;
				}
				
				if (mod.userData.trainingValue >= data.trainingValue) {
					mod.userCurrentLevelIndex.training = data.index;
				}
			});
		},

		updateStatusBar: function (sectionName) {
			var mod = this,
				section = mod.$ctx.find('.section.' + sectionName),
				currentBar = section.find('.bar.current'),
				targetBar = section.find('.bar.target'),
				currentBarWidth = 1,
				targetBarWidth = mod.levels[mod.userTargetLevelIndex].markerPosition + 1,
				currentValue = mod.userData[sectionName + 'Value'],
				level = mod.levels[mod.userCurrentLevelIndex[sectionName]],
				levelValue = level[sectionName + 'Value'],
				nextLevel = mod.levels[level.index + 1],
				nextLevelValue = (nextLevel ? nextLevel[sectionName + 'Value'] : 0);

			// current progressbar
			if (!mod.userHasNoLevel && (currentValue > 0 || currentValue === levelValue)) {
				// users value is higher then the highest level
				if (!nextLevel && currentValue > levelValue) {
					currentBarWidth = currentBar.parent().width();
				} else if (level.index === 0 && currentValue < levelValue) { // users value is lower then the first level
					currentBarWidth = Math.max(level.markerPosition / levelValue * currentValue, currentBarWidth);
				} else if (currentValue === levelValue || !nextLevel) { // users value is exactly at one levels value
					currentBarWidth = level.markerPosition + 1;
				} else {
					currentBarWidth = level.markerPosition + ((nextLevel.markerPosition - level.markerPosition) / (nextLevelValue - levelValue) * (currentValue - levelValue));
				}
			}
			
			currentBar.width(currentBarWidth);

			/* Adjust position of current callout
			 Because callout on mobile is located below progress bars, 
			 we don't need to calculate it position */  
			if (!SCS.utils.isMobilePage()) {
				mod.adjustCurrentCallout(currentBar, currentBarWidth);
			}

			// target progressbar
			if (currentBarWidth < targetBarWidth) {
				targetBar.css({
					width: ((targetBarWidth - currentBarWidth) + 1) + "px",
					left: (currentBarWidth - 1) + "px"
				});
				
				// Update separator line color
				mod.updateSeparatorLineColor(section, currentBarWidth);
			} else {
				section.find('.info-status').hide();
				targetBar.hide();
			}
		},

		adjustCurrentCallout: function (currentBar, currentBarWidth) {
			var mod = this,
				currentCalloutPosition,
				currentCallout,
				currentCalloutWidth,
				currentCalloutAvaillableWidth;

			if (currentBarWidth > mod.currentCalloutOffset) {
				currentCallout = currentBar.find('.current-callout');
				currentCalloutPosition = currentBarWidth - mod.currentCalloutOffset;
				currentCalloutWidth = currentCallout.outerWidth();
				currentCalloutAvaillableWidth = currentCallout.closest('.progressbar').width();
				if (currentCalloutPosition + currentCalloutWidth > currentCalloutAvaillableWidth) {
					currentCalloutPosition = currentCalloutAvaillableWidth - currentCalloutWidth;
				}
				currentCallout.css('left', currentCalloutPosition + 'px');
			}
		},
		
		/**
		 *  Prepare content for mobile platforms
		 */
		prepareMobileContent: function() {
			var $element;
				
			// Remove call-out classes
			this.$ctx.find('.call-out').each(function() {
				$element = $(this);
				$element.removeClass('call-out').addClass('info-status').insertAfter($element.closest('.progressbar'));
			});
		},
		
		/**
		 * Update separator border color line based on bar progress
		 * 
		 * @param section {Object} Wrapper element of progress bar
		 * @param currentBarWidth {Float} Current progress width 
		 */
		updateSeparatorLineColor: function(section, currentBarWidth) {
			var $element;
				
			section.find('.marker-line').each(function (index, element) {
				$element = $(element);
				if ($element.position().left > currentBarWidth) {
					$element.addClass('overlay-color');
				}
			});
		},
		
		/**
		 * Update both status bars if user view-port resize
		 */
		updateStatusBarsOnResize: function() {
			var mod = this;
			
			$(w).resize(function() {

                // Declare vars
                mod.declareVars();

                // get user data
                mod.userData = mod.$ctx.find('.userdata:first').data();
                if (mod.userData.level === "undefined" || mod.userData.level === "nodisplay") {
                    mod.userHasNoLevel = true;
                }

                // get available levels
                mod.getAvailableLevels();

                // update the status bars
                mod.updateStatusBar('sales');
                mod.updateStatusBar('training');
			});
		},
		
		/**
		 * Declare module vars
		 */
		declareVars: function() {
			var mod = this;
			
			// Config
			mod.currentCalloutOffset = 20;
	
			// vars
			mod.levels = [];
			mod.userData = {};
			mod.userHasNoLevel = false;
			mod.userTargetLevelIndex = 0;
			mod.userCurrentLevelIndex = {
				sales: 0,
				training: 0
			};
		}
	});
}(Tc.$, window, window.SCS));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PexMyStatus.js
// module id = 163
// module chunks = 0